export default __webpack_public_path__ + "static/update0001-5cce5a7f1102bc08d6a23fffd28fdcbd.png";